import React from 'react';
import { Text, Stack } from '@moda/om';
import { COUNTRIES } from '@moda/portal-stanchions';
import { PaymentMethodAttributes } from '../../../hooks/usePaymentMethods';
import { CardLogo } from '../../CardLogo';

import './PaymentMethodPreview.scss';

interface Props {
  method: PaymentMethodAttributes;
}

export const PaymentMethodPreview: React.FC<Props> = ({
  method: { lastFour, billingAddress, cardType, cardholderName, expirationDate, isValid }
}) => {
  if (!expirationDate) return null;
  const country = COUNTRIES.find(country => country.alpha2Code === billingAddress?.countryCode);
  const [expirationMonth, expirationYear] = expirationDate.split('/');
  const isExpired = new Date() > new Date(Number(expirationYear), Number(expirationMonth));

  return (
    <div className="PaymentMethodPreview">
      <CardLogo cardType={cardType} className="PaymentMethodPreview__image" />

      <Stack className="PaymentMethodPreview__info" space={0}>
        <Text>
          Ending in {lastFour}{' '}
          {isExpired ? (
            <Text color="code-red">(expired on {expirationDate})</Text>
          ) : (
            `(exp ${expirationDate})`
          )}
        </Text>
        <Text>{cardholderName}</Text>
        {country && <Text>{country.name}</Text>}

        {isValid === false && (
          <Text color="code-red">
            There is a problem with your card ending in {lastFour}. Please update your payment
            method.
          </Text>
        )}
      </Stack>
    </div>
  );
};
